import type { Localized, PageKey } from '../types/content'

export const seo: Record<PageKey, { path: string; title: Localized; description: Localized }> = {
  home: {
    path: '/',
    title: {
      en: 'A.M. Home Care, Inc. | Senior Home Care Woodbridge VA | 24/7 Caregiving',
      es: 'A.M. Home Care, Inc. | Cuidado en el Hogar Woodbridge VA | 24/7',
    },
    description: {
      en: "Professional in-home senior care in Northern Virginia. Compassionate caregivers for Alzheimer's, dementia & senior wellness. 24/7 service. Bilingual. Call (703) 231-7468",
      es: 'Cuidado de personas mayores en el hogar en el norte de Virginia. Cuidadores compasivos para Alzheimer y demencia. Servicio 24/7. Bilingüe. Llama al (703) 231-7468',
    },
  },
  services: {
    path: '/services',
    title: {
      en: "Senior Care Services | Alzheimer's & Dementia Care | A.M. Home Care",
      es: 'Servicios de Cuidado | Alzheimer y Demencia | A.M. Home Care',
    },
    description: {
      en: 'Comprehensive home care services for seniors: personal care, meal prep, medication management, dementia care & companionship. Woodbridge VA & Northern Virginia. Available 24/7.',
      es: 'Servicios de cuidado domiciliario: cuidado personal, comidas, medicamentos, cuidado de demencia y compañía. Woodbridge VA y el norte de Virginia. Disponible 24/7.',
    },
  },
  about: {
    path: '/about',
    title: {
      en: 'About A.M. Home Care | Compassionate Senior Care Virginia',
      es: 'Acerca de A.M. Home Care | Cuidado Compasivo en Virginia',
    },
    description: {
      en: 'Meet A.M. Home Care, Inc., a bilingual, licensed and insured home care agency in Woodbridge, VA serving families across Northern Virginia with loving, specialized care.',
      es: 'Conoce A.M. Home Care, Inc., agencia bilingüe, licenciada y asegurada en Woodbridge, VA, que sirve a familias en el norte de Virginia con cuidado amoroso y especializado.',
    },
  },
  testimonials: {
    path: '/testimonials',
    title: {
      en: 'Reviews & Testimonials | 5.0★ Home Care Woodbridge VA | A.M. Home Care',
      es: 'Reseñas y Testimonios | 5.0★ Cuidado en el Hogar | A.M. Home Care',
    },
    description: {
      en: 'Read 5-star Google reviews from Northern Virginia families who trust A.M. Home Care for dementia care, end-of-life comfort, and everyday senior care.',
      es: 'Lee reseñas de 5 estrellas en Google de familias del norte de Virginia que confían en A.M. Home Care para cuidado de demencia y de personas mayores.',
    },
  },
  contact: {
    path: '/contact',
    title: {
      en: 'Contact & Free Consultation | 24/7 Home Care Northern VA | A.M. Home Care',
      es: 'Contacto y Consulta Gratuita | Cuidado 24/7 | A.M. Home Care',
    },
    description: {
      en: 'Schedule a free home care consultation. Call or WhatsApp (703) 231-7468, available 24/7. Serving Woodbridge, Fairfax, Arlington, Alexandria & Loudoun.',
      es: 'Agenda una consulta gratuita de cuidado en el hogar. Llama o escribe por WhatsApp al (703) 231-7468, 24/7. Woodbridge, Fairfax, Arlington, Alexandria y Loudoun.',
    },
  },
  faq: {
    path: '/faq',
    title: {
      en: 'Home Care FAQ | Pricing, Dementia Care & Scheduling | A.M. Home Care',
      es: 'Preguntas Frecuentes | Precios, Demencia y Horarios | A.M. Home Care',
    },
    description: {
      en: 'Answers about in-home senior care costs, dementia care, bilingual caregivers, 24/7 scheduling and getting started with A.M. Home Care in Northern Virginia.',
      es: 'Respuestas sobre costos de cuidado en el hogar, cuidado de demencia, cuidadores bilingües, horarios 24/7 y cómo empezar con A.M. Home Care.',
    },
  },
  notFound: {
    path: '/',
    title: { en: 'Page not found | A.M. Home Care', es: 'Página no encontrada | A.M. Home Care' },
    description: {
      en: 'The page you were looking for could not be found.',
      es: 'No pudimos encontrar la página que buscabas.',
    },
  },
}
